import { useEffect } from "react";
import type { TypeShellFeatureType } from "../types";

export const useAppTitle = (config?: TypeShellFeatureType) => {
    useEffect(() => {
        if (!config?.gameName) {
            return;
        }
        const prefix = config.mode === "replay" ? "Replay" : "Game";

        document.title = `${prefix} - ${humanizeGameName(config.gameName)}`;
    }, [config?.gameName]);
};

const humanizeGameName = (name: string): string =>
    name
        .split("_")
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
